import { render, staticRenderFns } from "./ProyectoUbicacion.vue?vue&type=template&id=5dc72209&"
import script from "./ProyectoUbicacion.vue?vue&type=script&lang=js&"
export * from "./ProyectoUbicacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports